import {
	CHECK_RESTAURANT_OPERATION_SERVICE,
	GET_RESTAURANTS_BASED_ON_CATEGORY,
	GET_RESTAURANTS_CATEGORIES,
	GET_DELIVERY_RESTAURANTS,
	GET_SELFPICKUP_RESTAURANTS,
	GET_SPOTPICKUP_RESTAURANTS,
	GET_TABLE_RESTAURANTS,
	GET_FAVORITE_RESTAURANTS,
	GET_SUB_CATEGORIES,
	GET_FILTERED_RESTAURANTS_AND_ITEMS
} from "./actionTypes";
import {
	CHECK_RESTAURANT_OPERATION_SERVICE_URL,
	GET_RESTAURANTS_CATEGORIES_URL,
	GET_FILTERED_RESTAURANTS_URL,
	GET_DELIVERY_RESTAURANTS_URL,
	GET_SELFPICKUP_RESTAURANTS_URL,
	GET_SPOTPICKUP_RESTAURANTS_URL,
	GET_TABLE_RESTAURANTS_URL,
	GET_FAVORITE_RESTAURANTS_URL,
	GET_SUB_CATEGORIES_URL,
	GET_FILTERED_RESTAURANTS_AND_ITEMS_URL
} from "../../configs";
import apiClient from "../apiClient";
export const checkRestaurantOperationService = (restaurant_id, latitude, longitude) => (dispatch) => {
	apiClient.post(CHECK_RESTAURANT_OPERATION_SERVICE_URL, {
		restaurant_id: restaurant_id,
		latitude: latitude,
		longitude: longitude,
	})
		.then((response) => {
			const coupon = response.data;
			return dispatch({ type: CHECK_RESTAURANT_OPERATION_SERVICE, payload: coupon });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getRestaurantsBasedOnCategory = (lat, lng, category_ids, filters = {}) => (dispatch) => {
	apiClient.post(GET_FILTERED_RESTAURANTS_URL, {
		latitude: lat,
		longitude: lng,
		category_ids: category_ids,
		min_rating: filters.minRating || null,
		max_distance: filters.maxDistance || null,
		max_delivery_time: filters.maxDeliveryTime || null,
		delivery_type: filters.deliveryType || null,
		badges: filters.badges && filters.badges.length > 0 ? filters.badges : null,
		sort_by: filters.sortBy || null,
		sort_order: filters.sortOrder || "asc",
	})
		.then((response) => {
			const filtered_restaurants = response.data;
			return dispatch({
				type: GET_RESTAURANTS_BASED_ON_CATEGORY,
				payload: filtered_restaurants,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getRestaurantsCategories = (slug) => (dispatch) => {
	apiClient.post(GET_RESTAURANTS_CATEGORIES_URL)
		.then((response) => {
			const restaurants_categories = response.data;
			return dispatch({
				type: GET_RESTAURANTS_CATEGORIES,
				payload: restaurants_categories,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getDeliveryRestaurants = (lat, lng) => (dispatch) => {
	return apiClient.post(GET_DELIVERY_RESTAURANTS_URL, {
		latitude: lat,
		longitude: lng,
	})
		.then((response) => {
			const restaurants = response.data;
			return dispatch({
				type: GET_DELIVERY_RESTAURANTS,
				payload: restaurants,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getSelfpickupRestaurants = (lat, lng) => (dispatch) => {
	return apiClient.post(GET_SELFPICKUP_RESTAURANTS_URL, {
		latitude: lat,
		longitude: lng,
	})
		.then((response) => {
			const restaurants = response.data;
			return dispatch({
				type: GET_SELFPICKUP_RESTAURANTS,
				payload: restaurants,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getSpotpickupRestaurants = (lat, lng) => (dispatch) => {
	return apiClient.post(GET_SPOTPICKUP_RESTAURANTS_URL, {
		latitude: lat,
		longitude: lng,
	})
		.then((response) => {
			const restaurants = response.data;
			return dispatch({
				type: GET_SPOTPICKUP_RESTAURANTS,
				payload: restaurants,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getTableRestaurants = (lat, lng) => (dispatch) => {
	return apiClient.post(GET_TABLE_RESTAURANTS_URL, {
		latitude: lat,
		longitude: lng,
	})
		.then((response) => {
			const restaurants = response.data;
			return dispatch({
				type: GET_TABLE_RESTAURANTS,
				payload: restaurants,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getFavoriteRestaurants = (lat, lng) => (dispatch,getState) => {
	return apiClient.post(GET_FAVORITE_RESTAURANTS_URL, {
		token: getState().user.user.data.auth_token,
		latitude: lat,
		longitude: lng,
	})
		.then((response) => {
			const restaurants = response.data;
			return dispatch({
				type: GET_FAVORITE_RESTAURANTS,
				payload: restaurants,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getSubCategories = (parentId) => (dispatch) => {
	return apiClient.post(GET_SUB_CATEGORIES_URL, {
		parent_id: parentId,
	})
		.then((response) => {
			const sub_categories = response.data;
			return dispatch({
				type: GET_SUB_CATEGORIES,
				payload: sub_categories,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getFilteredRestaurantsAndItems = (lat, lng, category_ids, filters = {}) => (dispatch) => {
	return apiClient.post(GET_FILTERED_RESTAURANTS_AND_ITEMS_URL, {
		latitude: lat,
		longitude: lng,
		category_ids: category_ids,
		min_rating: filters.minRating || null,
		max_distance: filters.maxDistance || null,
		max_delivery_time: filters.maxDeliveryTime || null,
		delivery_type: filters.deliveryType || null,
		badges: filters.badges && filters.badges.length > 0 ? filters.badges : null,
		sort_by: filters.sortBy || null,
		sort_order: filters.sortOrder || "asc",
		result_type: filters.resultType || null,
	})
		.then((response) => {
			const data = response.data;
			return dispatch({
				type: GET_FILTERED_RESTAURANTS_AND_ITEMS,
				payload: data,
			});
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const clearRestaurantList = () => (dispatch) => {
	const restaurants = [];
	return dispatch({
		type: GET_DELIVERY_RESTAURANTS,
		payload: restaurants,
	});
};

